// @ts-nocheck
import { BfMetricTileSize, IStrikeZoneConfig, IStrikeZoneData, StrikeZoneDisplay } from '@trackman/baseball-shared-components';
import { Radio, RadioGroup } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Circle, Group, Text } from 'react-konva';
import { RadioItemWrapper, StrikeZoneWrapper, ViewTypeGroup } from './styles/StrikezoneViewStyles';

interface IProps {
  data: IStrikeZoneData[];
  darkMode?: boolean;
  config?: IStrikeZoneConfig;
}

enum ViewType {
  Batter = 'batter',
  Pitcher = 'pitcher',
}

export const StrikezoneView: React.FC<IProps> = observer(({ data, darkMode, config }) => {
  const [view, setView] = useState<ViewType>(ViewType.Batter);

  // const viewChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setView(event.target.value as ViewType);
  // };

  return (
    <StrikeZoneWrapper className='row' data-testid='strike-zone'>
      <StrikeZoneDisplay
        size={BfMetricTileSize.Small}
        data={data}
        markRenderer={(idx: number, x: number, y: number, radius: number) => {
          return (
            <Group key={idx} x={view === ViewType.Batter ? x : -x} y={y} opacity={idx > data.length - 10 ? 1 : 0.4}>
              <Circle fill='white' radius={radius - 2} stroke={idx === data.length ? '#EC691A' : '#A0A0A0'} strokeWidth={2} />
              <Text text={idx.toString()} offsetX={idx < 9 ? 2.5 : 5.5} offsetY={5} fontStyle='bold' fontFamily='Oswald' />
            </Group>
          );
        }}
        darkMode={darkMode}
        strikeZoneConfig={config}
      />
      {/* <ViewTypeGroup>
        <div>View</div>
        <RadioGroup defaultValue='light' onChange={viewChangeHandler}>
          <RadioItemWrapper>
            <Radio label="Batter's" value={ViewType.Batter} checked={view === ViewType.Batter} data-testid='batter-view' />
            <Radio label="Pitcher's" value={ViewType.Pitcher} checked={view === ViewType.Pitcher} data-testid='pitcher-view' />
          </RadioItemWrapper>
        </RadioGroup>
      </ViewTypeGroup> */}
    </StrikeZoneWrapper>
  );
});
